import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Videos from './components/Videos';
import Problem from './components/Problem';
import Systems from './components/Systems';
import Bonuses from './components/Bonuses';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <main className="bg-[#080808] overflow-x-hidden">
      <Navbar />
      <Hero />
      <Videos />
      <Problem />
      <Systems />
      <Bonuses />
      <Testimonials />
      <FAQ />
      <Contact />
      <CallToAction />
      <Footer />
    </main>
  );
}
